import { render, staticRenderFns } from "./ConfigManualBilling.vue?vue&type=template&id=54747f85&"
import script from "./ConfigManualBilling.vue?vue&type=script&lang=js&"
export * from "./ConfigManualBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports